import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { otpVerification } from "../../../Redux/Actions";
import "./Otp_verification.css"

function Otpverification() {
  const [otpverify, setOtpVerify] = useState("");
  const history = useHistory();
  const otpResponse = useSelector(state => state.otpLogin)
    const { loading : loadingotp, otploginResponse } = otpResponse
  
    const otpverification = useSelector(state => state.otpverification)
    const { loading , otpVerificationResponse , error} = otpverification
  const dispatch = useDispatch()

  useEffect(()=>{    
    if(error){
      history.push('/register')
    }
    else if(otpVerificationResponse && otpVerificationResponse.user){
      localStorage.setItem("user", JSON.stringify(otpVerificationResponse.user));
      // history.push('/')
      window.location.href = process.env.RAZZLE_APP_BASE_URL
    }
  },[loading]);

  const handleSubmit = () => {
  const otpverifyModel = { "user" : {
    "email" : `${otploginResponse.phone_number}`,
    "password" : `${otpverify}`
  }}
  setOtpVerify("")
  dispatch(otpVerification(otpverifyModel))
  }


 
  const handleChange = (event) => {
    setOtpVerify(event.target.value)
  }
  return (
    <div className="OtpVerificationContainer">
    <div className="welcome-redcilffe">
      <div className="row">
        <h2>Welcome to Redcliffe </h2>
      </div>
      <div className="login-row">
        <div className="left">
            <h1>image</h1>
            <img />
        </div>
        <div className="right">
          <div className="loginform">
            <div>
              <h1>Verify OTP</h1>
              <p>Please enter your Mobile Number to proceed</p>
              <img />
            </div>
            <form >
              
              <h2>{!loadingotp ? `${otploginResponse.phone_number}`: "LOADING"}</h2>

              <input onChange={handleChange} value = {otpverify} placeholder="Enter OTP" required></input>              
              <button type="submit" onClick = {handleSubmit}>
                Verify otp
              </button>
            </form>
           
          </div>
        </div>
      </div>
    </div>
  </div>
  );
}



export default {
  component: Otpverification
}
